export enum SalesRequirements {
  HeartwormPrescriptionRestrictions = 'Heartworm'
}
